/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodataBatchDeleteReqVo
 */
export interface NodataBatchDeleteReqVo {
    /**
     * 国家ID（1=韩国 2=中国）
     * @type {number}
     * @memberof NodataBatchDeleteReqVo
     */
    nationId: number;
    /**
     * 无数据类型：1=一般无数据 2=返送无数据（仅韩国，中国仅有1）；废弃无数据不支持批量删除
     * @type {number}
     * @memberof NodataBatchDeleteReqVo
     */
    nodataType: number;
    /**
     * 删除类型：1=截至一年前的所有无数据 2=截至一年前最终完成的无数据
     * @type {number}
     * @memberof NodataBatchDeleteReqVo
     */
    deleteType: number;
}

/**
 * Check if a given object implements the NodataBatchDeleteReqVo interface.
 */
export function instanceOfNodataBatchDeleteReqVo(value: object): value is NodataBatchDeleteReqVo {
    if (!('nationId' in value) || value['nationId'] === undefined) return false;
    if (!('nodataType' in value) || value['nodataType'] === undefined) return false;
    if (!('deleteType' in value) || value['deleteType'] === undefined) return false;
    return true;
}

export function NodataBatchDeleteReqVoFromJSON(json: any): NodataBatchDeleteReqVo {
    return NodataBatchDeleteReqVoFromJSONTyped(json, false);
}

export function NodataBatchDeleteReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataBatchDeleteReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'nationId': json['nationId'],
        'nodataType': json['nodataType'],
        'deleteType': json['deleteType'],
    };
}

export function NodataBatchDeleteReqVoToJSON(json: any): NodataBatchDeleteReqVo {
    return NodataBatchDeleteReqVoToJSONTyped(json, false);
}

export function NodataBatchDeleteReqVoToJSONTyped(value?: NodataBatchDeleteReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nationId': value['nationId'],
        'nodataType': value['nodataType'],
        'deleteType': value['deleteType'],
    };
}

